import api from "../../API/apiConfig";

// 1. Thêm mới Account (Company)
export const addCompany = async (companyData) => {
  return await api.post("/accounts/add", companyData);
};

// 2. Cập nhật Account
export const updateCompany = async (id, companyData) => {
  return await api.put(`/accounts/update/${id}`, companyData);
};

// 3. Lấy danh sách Account
export const getAllCompanies = async () => {
  return await api.get(`/accounts/list-all`);
};

// 4. Xóa Account
export const deleteCompany = async (id) => {
  return await api.delete(`/accounts/delete/${id}`);
};

// 5. Lấy chi tiết Account
export const getCompanyDetail = async (id) => {
  return await api.get(`/accounts/detail/${id}`);
};

// 6. Lấy tất cả danh sách Account không phân trang
export const getAllCompaniesWithoutPaging = async () => {
  return await api.get("/accounts/list-all");
};

// 7. Get All Companies
export const getCompanies = async (params) => {
  const queryParams = {
    ...params,
    ownerAlias: params.ownerAlias?.length ? params.ownerAlias : undefined,
  };
  console.log("Param", queryParams);
  console.log("Param", params);
  return await api.get("/accounts", { params: queryParams,
     paramsSerializer: {
    indexes: null, 
  }});
};
//8 . Get Accessibility cho Company
export const getAccessibilityForAccount = async (id) => {
  return await api.get(`/accounts/accessibility/${id}`);
};

//9. Update Accessibility cho Company
export const updateAccessibilityForAccount = async (id, data) => {
  return await api.post(`/accounts/update-access/${id}`, data);
};

//10. Change Owner
export const changeOwner = async (accountIds, newOwnerUuid) => {
  return await api.put("/accounts/change-owner", { accountIds, newOwnerUuid });
};

